import { Badge, FieldGroup } from '@/ui'
import { XClose } from '@/icons'
import { Button, FormErrorMessage, Plus, useModal } from '@dashboard/ui'
import { useFormContext } from 'react-hook-form'
import { WebhookCreate } from '@/api/dashboard'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from '@hookform/error-message'
import { SelectEventsStageModal } from './SelectEventsStageModal'

export const SelectEventsButton = (props: { currentWebhookId?: string }) => {
  const { t } = useTranslation()

  const {
    setValue,
    clearErrors,
    watch,
    formState: { errors },
  } = useFormContext<WebhookCreate>()

  const events = watch('events') || []

  const onClickRemoveEvent = (event: string) => {
    setValue(
      'events',
      events.filter(e => e !== event),
      { shouldDirty: true },
    )
  }

  const openSelectEventsStageModal = useModal(props1 => (
    <SelectEventsStageModal
      {...props1}
      currentWebhookId={props.currentWebhookId}
      events={events}
      onSubmitData={data => {
        setValue('events', data.events, { shouldDirty: true })
        clearErrors('events')
      }}
    />
  ))

  return (
    <FieldGroup>
      <div className="mb-3 text-caption-lg font-semibold">{t('webhook.form.select-events.title')}</div>
      {!!events.length && (
        <div className="mb-2 flex flex-wrap gap-3">
          {events.map(event => (
            <Badge key={`event-${event}`} variant="gray-tertiary">
              <span className="truncate">{t(`webhook.event.${event}.label`)}</span>
              <button
                className="-mx-0.5 cursor-pointer rounded-md p-0.5 transition-all hover:text-text-brand-primary"
                type="button"
                onClick={() => onClickRemoveEvent(event)}
              >
                <XClose size={16} />
              </button>
            </Badge>
          ))}
        </div>
      )}
      <Button variant="outline" type="button" onClick={() => openSelectEventsStageModal()}>
        <Plus size={18} />
        <span>{t('webhook.form.select-events.button')}</span>
      </Button>

      <ErrorMessage
        name="events"
        errors={errors}
        render={({ message }) => <FormErrorMessage>{message}</FormErrorMessage>}
      />
    </FieldGroup>
  )
}
